module.exports = TextEncoder;


//////////////////
// WEBPACK FOOTER
// external "TextEncoder"
// module id = 115
// module chunks = 0